import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1.5),
    minWidth: '25%',
    [theme.breakpoints.down('xs')]: {
      minWidth: '50%',
    },
  },
  head: {
    fontWeight: 500,
    color: '#a9a9a9',
  },
  body: {
    fontWeight: 500,
    textTransform: 'capitalize',
  },
}));

function EachRec({ head, body }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography gutterBottom variant="caption" className={classes.head}>
        {head}
      </Typography>
      <Typography gutterBottom variant="caption" className={classes.body}>
        {body}
      </Typography>
    </div>
  );
}

export default EachRec;
